import moment from 'moment'
import {useRoute} from '#app';

export class MetaDataService {
  constructor(app, axios, store, cmsUrl, frontendUrl) {
    this.app = app;
    this.$axios = axios;
    this.store = store;
    this.cmsUrl = cmsUrl;
    this.frontendUrl = frontendUrl;
  }

  async createHeadObject(metaData, structuredData, orgData, reviews, aggReviewData, localBusData) {
    var meta = [];
    var sd = [];

    // Some callers provide structuredData as an array or an object.
    if (!structuredData) {
      structuredData = [];
    }
    else if (!Array.isArray(structuredData)) {
      structuredData = [structuredData];
    }

    var title = null;
    if(metaData != undefined)
    {
      // Add base meta data
      for (const [key, value] of Object.entries(metaData)) {
        if (value !== undefined && value !== null) {
          meta.push({
            hid: key,
            name: key,
            content: value,
          });
          if(key == "title")
          {
            title = value;
          }
        }
      }
    }

    if (orgData) {
      structuredData.push(orgData);
    } else {
      var orgData = await this.getOrganizationStructuredData();
      if (orgData) {
        structuredData.push(orgData);
      }
    }

    if (reviews && reviews.length > 0) {
      reviews.forEach(function(review) {
        structuredData.push(review.structured_data);
      });
    }

    if (aggReviewData) {
      structuredData.push(aggReviewData);
    }

    if (localBusData) {
      structuredData.push(localBusData);
    }

    // Collect and parse all structured data
    structuredData.filter((sd) => !!sd).forEach(function(data) {
      if (typeof data === 'string' || data instanceof String) {
        try {
          var parsedData = JSON.parse(data);
          if (Array.isArray(parsedData)) {
            parsedData.forEach(function(innerData) {
              if (!!innerData) {
                sd.push(innerData);
              }
            });
          } else if (!!parsedData) {
            sd.push(parsedData);
          }
        } catch (e) {
          console.error('Invalid structured data JSON ' + data);
          console.error(e);
        }
      } else if (Array.isArray(data)) {
        data.forEach(function(innerData) {
          sd.push(innerData);
        });
      } else {
        sd.push(data);
      }
    });

    let domain = this.frontendUrl.endsWith("/") ? this.frontendUrl.substring(0, this.frontendUrl.length - 1) : this.frontendUrl;
    let path = useRoute().fullPath;
    path = path.split('?')[0];
    
    var result = {
      meta: meta,
      link: [
        {
          rel: 'canonical',
          href: domain + path + '/',
        },
      ]
    };

    if (sd && sd.length > 0) {
      result.script = [
        { 
          type: 'application/ld+json',
          json: sd,
        },
      ];
    }
    if(title)
    {
      result.title = title;
    }

    return result;
  }

  async getOrganizationStructuredData() {
    return await this.$axios.get(this.cmsUrl + "structureddata/organization")
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error('Error getting cms path structureddata/organization');
        console.error(error);
        return undefined;
      });
  }

  async getAggregateRatingStructuredData(branch) {
    return await this.$axios.get(this.cmsUrl + "structureddata/aggregaterating/" + (branch ? branch : ""))
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        console.error('Error getting cms path structureddata/aggregaterating/' + (branch ? branch : ''));
        console.error(error);
        return undefined;
      });
  }

  createRobotsString(meta_robots_index, meta_robots_follow) {
    var index = meta_robots_index ? meta_robots_index : 'noindex';
    var follow = meta_robots_follow ? meta_robots_follow : 'nofollow';
    return index + ',' + follow
  }

  async collectReviewStructuredData(reviews, branch, structuredData) {
    if (!structuredData) {
      structuredData = [];
    }

    // Get structured data from each review
    if (reviews) {
      reviews.forEach(function(review) {
        structuredData.push(review.structured_data);
      });
    }

    // Collect aggregate reviews
    var aggData = await this.getAggregateRatingStructuredData(branch);
    if (aggData) {
      structuredData.push(aggData);
    }

    return structuredData;
  }

  updateUrlTracking() {
    const startOfToday = moment(Date.now()).startOf("day");

    const landingUrlFullPath = this.store.state.persistedState?.metadata?.landingUrl?.fullPath;
    const landingUrlOn = this.store.state.persistedState?.metadata?.landingUrl?.on;
    if (!landingUrlFullPath || moment(landingUrlOn).isBefore(startOfToday)) {
      this.store.dispatch("updateMetadataLandingUrl", useRoute().fullPath);
    }

    // const referrerUrlFullPath = this.store.state.persistedState?.metadata?.referrerUrl?.fullPath;
    // const referrerUrlOn = this.store.state.persistedState?.metadata?.referrerUrl?.on;
    // if (!referrerUrlFullPath || moment(referrerUrlOn).isBefore(startOfToday)) {
    //   this.store.dispatch("updateMetadataReferrerUrl", this.req?.headers?.referrer);
    // }
  }

  getPageMetadataObj() {
    const route = useRoute();
    const query = route.query;

    let tags = Object.keys(query).map((x) => { return { item1: x, item2: query[x] }; });
    tags.push({ item1: "referrerUrl", item2: this.store.state.persistedState?.metadata?.referrerUrl?.fullPath });
    tags.push({ item1: "landingUrl", item2: this.store.state.persistedState?.metadata?.landingUrl?.fullPath });
    tags.push({ item1: "formSubmissionUrl", item2: route.path });

    return {
      metaData: {
        tags: tags,
      }
    };
  }
}